import * as React from 'react';
import * as styles from './styles.css';
import { IFileFieldValue } from '../../../../types/file';
import { Spinner } from '@cian/ui-kit';
import { useToggleState } from '@cian/react-utils';

export interface IFilePreviewImageProps {
  file: IFileFieldValue;
}

export const FilePreviewImage: React.FC<IFilePreviewImageProps> = props => {
  const { state: isLoading, toggle: toggleIsLoading } = useToggleState(true);

  return (
    <div className={styles['thumb']} key={props.file.name}>
      <div className={styles['thumb-inner']}>
        {isLoading && (
          <div className={styles['spinner']}>
            <Spinner />
          </div>
        )}
        <img
          src={props.file.preview}
          className={styles[`img-rotate-${props.file.rotateDegree}`]}
          onLoad={toggleIsLoading}
        />
      </div>
    </div>
  );
};
